export default __webpack_public_path__ + "static/media/default.820a2cda54c654cdece950739d385d9e.png";